export default {
      id: "icon-triangle-usage",
      viewBox: "0 0 7 6",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#icon-triangle",
      toString: function () {
        return this.url;
      }
    }